import { render, staticRenderFns } from "./MemberSet.vue?vue&type=template&id=991debf8&scoped=true"
import script from "./MemberSet.vue?vue&type=script&lang=js"
export * from "./MemberSet.vue?vue&type=script&lang=js"
import style0 from "./MemberSet.vue?vue&type=style&index=0&id=991debf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991debf8",
  null
  
)

export default component.exports